var customTextValue;
  
let productImageBlank;

 
let useCloud = 2;
//let cloudURL = "https://d18vs3cajeo1y7.cloudfront.net";
let cloudURL = "https://personaliser-images.s3.us-east-2.amazonaws.com";
let cloudFolder = "bornfree";

let debug = 0;
let showBounds = 0;
let originalFontSize = 137;
let originalRatio = ratio = 1;
let gutter = 0; // gutter around boundary?
let verticalAlignment = 'center'; // top,center,bottom
let horizontalAlignment = 'center'; // left,center,right
let fontFamilyArray = ["Papercute"]; //must load fonts for use
let primaryFontColor = "#FFFFFF"; //
let primaryFontColor2 = false;
let gradientDirection = "vertical";
let gradOffset = 0; // 0-0.49 moves gradient as % within a letter box
let dropshadow = false;
let dropshadowScale = true;
let shadowFontColor = "rgba(0, 0, 0, .5)"; //
let shadowBlur = 0;
let shadowOffsetX = 0;
let shadowOffsetY = 0;
let centerRotationDeg = 0;
let centerRotationX = 0;
let centerRotationY = 0;
let caseRule = "uppercase"; // none / capitalize / uppercase / lowercase
let fontSizeRatio = 1.6; //only change for central vertical alignment
let textArray = [];
let bespokeValue = "";
let bespokePrefix = "";
let bespokePrefix2 = 0;
let bespokeSuffix = "";
let bespokeSuffix2 = "";
let fontFamilyBase = "Papercute";
let duplicateText = "none"; // none / before / after
let duplicateTextSpacer = "-"; // Dupelication text spacer
let stroke = false;
let strokeScale = true;
let strokeColor = "#FF00FF";
let strokeWidth = 0;
let strokeBlur = 0;
let stroke2 = false;
let strokeWidth2 = 0;
let strokeBlur2 = 0;
let canvasHeight = 1024;
let canvasWidth = 1024;
let productType = "";
let orientation = ""; // landscape,portrait
let zoom = 1; //adjust overall size of canvas
//let textLength; //default text length,
let textLengthBox = "max-length-1";
let multilineText = false;
let lineHeight = 100;


//REMOVE ATTRIBUTES FUNCTION
function removeAtt(sku) {
	if(sku.indexOf('PAPRON') >=0){
		sku = sku.replace('_PAPRON_KIDS','_PAPRON');
		sku = sku.replace('_PAPRON_ADULTS','_PAPRON');
		sku = sku.replace('_PAPRON_ADULT','_PAPRON');
		sku = sku.replace('_PAPRONKIDS','_PAPRON');
		sku = sku.replace('_PAPRONADULTS','_PAPRON');
		sku = sku.replace('_PAPRONADULT','_PAPRON');
	}
	if(sku.indexOf('APRON') >=0){
		sku = sku.replace('_APRON_KIDS','_APRON');
		sku = sku.replace('_APRON_ADULTS','_APRON');
		sku = sku.replace('_APRON_ADULT','_APRON');
		sku = sku.replace('_APRONKIDS','_APRON');
		sku = sku.replace('_APRONADULTS','_APRON');
		sku = sku.replace('_APRONADULT','_APRON');
	}
	if(sku.indexOf('PRINT') >=0){
		sku = sku.replace('_PRINTFW','_PRINT');
		sku = sku.replace('_PRINTFB','_PRINT');
	}
	if(sku.indexOf('JIGSAW') >=0){
		sku = sku.replace('_JIGSAWSML','_JIGSAW');
		sku = sku.replace('_JIGSAWBIG','_JIGSAW');
	}
	if(sku.indexOf('PBABYGROW') >= 0){
		sku = sku.replace('_PBABYGROW_0-3','_PBABYGROW');
		sku = sku.replace('_PBABYGROW_3-6','_PBABYGROW');
		sku = sku.replace('_PBABYGROW_6-12','_PBABYGROW');
		sku = sku.replace('_PBABYGROW_12-18','_PBABYGROW');
	}
	if(sku.indexOf('PLUNCH') >= 0){
		sku = sku.replace('_PLUNCH-BLU','_PLUNCH');
		sku = sku.replace('_PLUNCH-PIN','_PLUNCH');
		sku = sku.replace('_PLUNCH_BLU','_PLUNCH');
		sku = sku.replace('_PLUNCH_PIN','_PLUNCH');
		sku = sku.replace('_PLUNCHBLUE','_PLUNCH');
		sku = sku.replace('_PLUNCHPINK','_PLUNCH');
	}
	if(sku.indexOf('LUNCH') >= 0){
		sku = sku.replace('_LUNCH-BLU','_LUNCH');
		sku = sku.replace('_LUNCH-PIN','_LUNCH');
		sku = sku.replace('_LUNCH_BLU','_LUNCH');
		sku = sku.replace('_LUNCH_PIN','_LUNCH');
		sku = sku.replace('_LUNCHBLUE','_LUNCH');
		sku = sku.replace('_LUNCHPINK','_LUNCH');
	}
	if(sku.indexOf('PPHONECASE') >= 0){
		sku = sku.replace('_PPHONECASE','_PPHONE');
	}
	if(sku.indexOf('PPHONE') >= 0){
		sku = sku.replace('_PPHONE_IPHONE6','_PPHONE');
		sku = sku.replace('_PPHONE_IPHONE7','_PPHONE');
		sku = sku.replace('_PPHONE_IPHONE8','_PPHONE');
		sku = sku.replace('_PPHONE_IPHONE6PLUS','_PPHONE');
		sku = sku.replace('_PPHONE_IPHONE7PLUS','_PPHONE');
		sku = sku.replace('_PPHONE_IPHONE8PLUS','_PPHONE');
	}
	if(sku.indexOf('PSQPRINT') >=0){
		sku = sku.replace('_PSQPRINT_SML','_PSQPRINT');
		sku = sku.replace('_PSQPRINT_LRG','_PSQPRINT');
		sku = sku.replace('_PSQPRINTFRAMEDWHITE_SML','_PSQPRINT');
		sku = sku.replace('_PSQPRINTFRAMEDWHITE_LRG','_PSQPRINT');
	}
	if(sku.indexOf('SQPRINT') >=0){
		sku = sku.replace('_SQPRINT_SML','_SQPRINT');
		sku = sku.replace('_SQPRINT_LRG','_SQPRINT');
		sku = sku.replace('_SQPRINTFRAMEDWHITE_SML','_SQPRINT');
		sku = sku.replace('_SQPRINTFRAMEDWHITE_LRG','_SQPRINT');
	}
	if(sku.indexOf('PTSHIRT') >= 0){
		sku = sku.replace('_PTSHIRT_1-2','_PTSHIRT');
		sku = sku.replace('_PTSHIRT_3-4','_PTSHIRT');
		sku = sku.replace('_PTSHIRT_5-6','_PTSHIRT');
		sku = sku.replace('_PTSHIRT_7-8','_PTSHIRT');
		sku = sku.replace('_PTSHIRT_9-10','_PTSHIRT');
		sku = sku.replace('_PTSHIRT_9-11','_PTSHIRT');
		sku = sku.replace('_PTSHIRT_12-14','_PTSHIRT');
		sku = sku.replace('_PTSHIRT_SML','_PTSHIRT');
		sku = sku.replace('_PTSHIRT_MED','_PTSHIRT');
		sku = sku.replace('_PTSHIRT_LRG','_PTSHIRT');
		sku = sku.replace('_PTSHIRT_XL','_PTSHIRT');
		sku = sku.replace('_PTSHIRT_XXL','_PTSHIRT');
	}

	if(sku.indexOf('PTSHIRTYELLOW') >= 0){
		sku = sku.replace('_PTSHIRTYELLOW_1-2','_PTSHIRT');
		sku = sku.replace('_PTSHIRTYELLOW_3-4','_PTSHIRT');
		sku = sku.replace('_PTSHIRTYELLOW_5-6','_PTSHIRT');
		sku = sku.replace('_PTSHIRTYELLOW_7-8','_PTSHIRT');
		sku = sku.replace('_PTSHIRTYELLOW_9-10','_PTSHIRT');
		sku = sku.replace('_PTSHIRTYELLOW_SML','_PTSHIRT');
		sku = sku.replace('_PTSHIRTYELLOW_MED','_PTSHIRT');
		sku = sku.replace('_PTSHIRTYELLOW_LRG','_PTSHIRT');
		sku = sku.replace('_PTSHIRTYELLOW_XL','_PTSHIRT');
		sku = sku.replace('_PTSHIRTYELLOW_XXL','_PTSHIRT');
	}
	if(sku.indexOf('PTSHIRTBLUE') >= 0){
		sku = sku.replace('_PTSHIRTBLUE_1-2','_PTSHIRT');
		sku = sku.replace('_PTSHIRTBLUE_3-4','_PTSHIRT');
		sku = sku.replace('_PTSHIRTBLUE_5-6','_PTSHIRT');
		sku = sku.replace('_PTSHIRTBLUE_7-8','_PTSHIRT');
		sku = sku.replace('_PTSHIRTBLUE_9-10','_PTSHIRT');
		sku = sku.replace('_PTSHIRTBLUE_SML','_PTSHIRT');
		sku = sku.replace('_PTSHIRTBLUE_MED','_PTSHIRT');
		sku = sku.replace('_PTSHIRTBLUE_LRG','_PTSHIRT');
		sku = sku.replace('_PTSHIRTBLUE_XL','_PTSHIRT');
		sku = sku.replace('_PTSHIRTBLUE_XXL','_PTSHIRT');
	}
	if(sku.indexOf('PTSHIRTGREEN') >= 0){
		sku = sku.replace('_PTSHIRTGREEN_1-2','_PTSHIRT');
		sku = sku.replace('_PTSHIRTGREEN_3-4','_PTSHIRT');
		sku = sku.replace('_PTSHIRTGREEN_5-6','_PTSHIRT');
		sku = sku.replace('_PTSHIRTGREEN_7-8','_PTSHIRT');
		sku = sku.replace('_PTSHIRTGREEN_9-10','_PTSHIRT');
		sku = sku.replace('_PTSHIRTGREEN_SML','_PTSHIRT');
		sku = sku.replace('_PTSHIRTGREEN_MED','_PTSHIRT');
		sku = sku.replace('_PTSHIRTGREEN_LRG','_PTSHIRT');
		sku = sku.replace('_PTSHIRTGREEN_XL','_PTSHIRT');
		sku = sku.replace('_PTSHIRTGREEN_XXL','_PTSHIRT');
	}
	if(sku.indexOf('PTSHIRTGREY') >= 0){
		sku = sku.replace('_PTSHIRTGREY_1-2','_PTSHIRT');
		sku = sku.replace('_PTSHIRTGREY_3-4','_PTSHIRT');
		sku = sku.replace('_PTSHIRTGREY_5-6','_PTSHIRT');
		sku = sku.replace('_PTSHIRTGREY_7-8','_PTSHIRT');
		sku = sku.replace('_PTSHIRTGREY_9-10','_PTSHIRT');
		sku = sku.replace('_PTSHIRTGREY_SML','_PTSHIRT');
		sku = sku.replace('_PTSHIRTGREY_MED','_PTSHIRT');
		sku = sku.replace('_PTSHIRTGREY_LRG','_PTSHIRT');
		sku = sku.replace('_PTSHIRTGREY_XL','_PTSHIRT');
		sku = sku.replace('_PTSHIRTGREY_XXL','_PTSHIRT');
	}
	if(sku.indexOf('PTSHIRTRED') >= 0){
		sku = sku.replace('_PTSHIRTRED_1-2','_PTSHIRT');
		sku = sku.replace('_PTSHIRTRED_3-4','_PTSHIRT');
		sku = sku.replace('_PTSHIRTRED_5-6','_PTSHIRT');
		sku = sku.replace('_PTSHIRTRED_7-8','_PTSHIRT');
		sku = sku.replace('_PTSHIRTRED_9-10','_PTSHIRT');
		sku = sku.replace('_PTSHIRTRED_SML','_PTSHIRT');
		sku = sku.replace('_PTSHIRTRED_MED','_PTSHIRT');
		sku = sku.replace('_PTSHIRTRED_LRG','_PTSHIRT');
		sku = sku.replace('_PTSHIRTRED_XL','_PTSHIRT');
		sku = sku.replace('_PTSHIRTRED_XXL','_PTSHIRT');
	}

	if(sku.indexOf('TSHIRT') >= 0){
		sku = sku.replace('_TSHIRT_1-2','_TSHIRT');
		sku = sku.replace('_TSHIRT_3-4','_TSHIRT');
		sku = sku.replace('_TSHIRT_5-6','_TSHIRT');
		sku = sku.replace('_TSHIRT_7-8','_TSHIRT');
		sku = sku.replace('_TSHIRT_9-10','_TSHIRT');
		sku = sku.replace('_TSHIRT_9-11','_TSHIRT');
		sku = sku.replace('_TSHIRT_12-14','_TSHIRT');
		sku = sku.replace('_TSHIRT_SML','_TSHIRT');
		sku = sku.replace('_TSHIRT_MED','_TSHIRT');
		sku = sku.replace('_TSHIRT_LRG','_TSHIRT');
		sku = sku.replace('_TSHIRT_XL','_TSHIRT');
		sku = sku.replace('_TSHIRT_XXL','_TSHIRT');
	}

	if(sku.indexOf('TSHIRTYELLOW') >= 0){
		sku = sku.replace('_TSHIRTYELLOW_1-2','_TSHIRT');
		sku = sku.replace('_TSHIRTYELLOW_3-4','_TSHIRT');
		sku = sku.replace('_TSHIRTYELLOW_5-6','_TSHIRT');
		sku = sku.replace('_TSHIRTYELLOW_7-8','_TSHIRT');
		sku = sku.replace('_TSHIRTYELLOW_9-10','_TSHIRT');
		sku = sku.replace('_TSHIRTYELLOW_SML','_TSHIRT');
		sku = sku.replace('_TSHIRTYELLOW_MED','_TSHIRT');
		sku = sku.replace('_TSHIRTYELLOW_LRG','_TSHIRT');
		sku = sku.replace('_TSHIRTYELLOW_XL','_TSHIRT');
		sku = sku.replace('_TSHIRTYELLOW_XXL','_TSHIRT');
	}
	if(sku.indexOf('TSHIRTBLUE') >= 0){
		sku = sku.replace('_TSHIRTBLUE_1-2','_TSHIRT');
		sku = sku.replace('_TSHIRTBLUE_3-4','_TSHIRT');
		sku = sku.replace('_TSHIRTBLUE_5-6','_TSHIRT');
		sku = sku.replace('_TSHIRTBLUE_7-8','_TSHIRT');
		sku = sku.replace('_TSHIRTBLUE_9-10','_TSHIRT');
		sku = sku.replace('_TSHIRTBLUE_SML','_TSHIRT');
		sku = sku.replace('_TSHIRTBLUE_MED','_TSHIRT');
		sku = sku.replace('_TSHIRTBLUE_LRG','_TSHIRT');
		sku = sku.replace('_TSHIRTBLUE_XL','_TSHIRT');
		sku = sku.replace('_TSHIRTBLUE_XXL','_TSHIRT');
	}
	if(sku.indexOf('TSHIRTGREEN') >= 0){
		sku = sku.replace('_TSHIRTGREEN_1-2','_TSHIRT');
		sku = sku.replace('_TSHIRTGREEN_3-4','_TSHIRT');
		sku = sku.replace('_TSHIRTGREEN_5-6','_TSHIRT');
		sku = sku.replace('_TSHIRTGREEN_7-8','_TSHIRT');
		sku = sku.replace('_TSHIRTGREEN_9-10','_TSHIRT');
		sku = sku.replace('_TSHIRTGREEN_SML','_TSHIRT');
		sku = sku.replace('_TSHIRTGREEN_MED','_TSHIRT');
		sku = sku.replace('_TSHIRTGREEN_LRG','_TSHIRT');
		sku = sku.replace('_TSHIRTGREEN_XL','_TSHIRT');
		sku = sku.replace('_TSHIRTGREEN_XXL','_TSHIRT');
	}
	if(sku.indexOf('TSHIRTGREY') >= 0){
		sku = sku.replace('_TSHIRTGREY_1-2','_TSHIRT');
		sku = sku.replace('_TSHIRTGREY_3-4','_TSHIRT');
		sku = sku.replace('_TSHIRTGREY_5-6','_TSHIRT');
		sku = sku.replace('_TSHIRTGREY_7-8','_TSHIRT');
		sku = sku.replace('_TSHIRTGREY_9-10','_TSHIRT');
		sku = sku.replace('_TSHIRTGREY_SML','_TSHIRT');
		sku = sku.replace('_TSHIRTGREY_MED','_TSHIRT');
		sku = sku.replace('_TSHIRTGREY_LRG','_TSHIRT');
		sku = sku.replace('_TSHIRTGREY_XL','_TSHIRT');
		sku = sku.replace('_TSHIRTGREY_XXL','_TSHIRT');
	}
	if(sku.indexOf('TSHIRTRED') >= 0){
		sku = sku.replace('_TSHIRTRED_1-2','_TSHIRT');
		sku = sku.replace('_TSHIRTRED_3-4','_TSHIRT');
		sku = sku.replace('_TSHIRTRED_5-6','_TSHIRT');
		sku = sku.replace('_TSHIRTRED_7-8','_TSHIRT');
		sku = sku.replace('_TSHIRTRED_9-10','_TSHIRT');
		sku = sku.replace('_TSHIRTRED_SML','_TSHIRT');
		sku = sku.replace('_TSHIRTRED_MED','_TSHIRT');
		sku = sku.replace('_TSHIRTRED_LRG','_TSHIRT');
		sku = sku.replace('_TSHIRTRED_XL','_TSHIRT');
		sku = sku.replace('_TSHIRTRED_XXL','_TSHIRT');
	}

	if(sku.indexOf('BABYGROW') >= 0){
		sku = sku.replace('_BABYGROW_0-3','_BABYGROW');
		sku = sku.replace('_BABYGROW_3-6','_BABYGROW');
		sku = sku.replace('_BABYGROW_6-12','_BABYGROW');
		sku = sku.replace('_BABYGROW_12-18','_BABYGROW');
	}

	return sku;
}

//CATCH VARIANT COLOUR
function getVariant(sku) {
	let variant = null;

	if (sku.indexOf('FRAMEDWHITE') >= 0 || sku.indexOf('FW') >= 0) {
		variant = "FRAMEDWHITE";
	}
	if (sku.indexOf('FRAMEDBLACK') >= 0 || sku.indexOf('FB') >= 0) {
		variant = "FRAMEDBLACK";
	}
	if (sku.indexOf('YELLOW') >= 0) {
		variant = "YELLOW";
	}
	if (sku.indexOf('GREEN') >= 0) {
		variant = "GREEN";
	}
	if (sku.indexOf('GREY') >= 0) {
		variant = "GREY";
	}
	if (sku.indexOf('RED') >= 0) {
		variant = "RED";
	}
	if (sku.indexOf('BLUE') >= 0 || sku.indexOf('BLU') >= 0) {
		variant = "BLUE";
	}
	if (sku.indexOf('PINK') >= 0 || sku.indexOf('PIN') >= 0) {
		variant = "PINK";
	}

	return variant;
}

/*
// Max length of product text
function getMaxLength(sku, index) {
	if(productArray.find(o => o.sku === sku)){
		if(index) {
			return productArray.find(o => o.sku === sku).text[parseInt(index)].textLength;
		}
		if(productArray.find(o => o.sku === sku).textLength){
			return productArray.find(o => o.sku === sku).textLength;
		}
	}
	return textLength;
}
*/
(function( w, $ ) {
	personalizer = function (_sku,_debug){
		var canvas = document.getElementById('canvas'),
			ctx = canvas.getContext('2d');
		ctx.fillStyle = "rgba(255, 255, 255, 0)";
		ctx.fillRect(0, 0, canvas.width, canvas.height);

		var fullSKU = _sku.toUpperCase();
		var pcode = _sku.toUpperCase();

		if(useCloud == 0) {
			//Removes second image from slider
			var slider = document.getElementById('personalised-slider-track');
			slider.removeChild(slider.querySelectorAll('li')[1]);
		}

		if (pcode) {

			pcode = removeAtt(pcode);

			for (var i = 0; i < productArray.length; i++) {
				//--------
				//PRIMARY
				//--------
				_sku = productArray[i].sku;
				_canvasHeight = productArray[i].canvasHeight;
				_canvasWidth = productArray[i].canvasWidth;
				//_textLength = getMaxLength(pcode);

				if (pcode == _sku) {
					//--------
					//PRIMARY
					//--------
					sku = _sku;
					if (productArray[i].text) {
						textArray = productArray[i].text;
					};
					// Old method start --- deprecated
					if (productArray[i].originalFontSize) {
						originalFontSize = productArray[i].originalFontSize;
					};
					if (productArray[i].xL) {
						xL = productArray[i].xL;
					};
					if (productArray[i].yT) {
						yT = productArray[i].yT;
					};
					if (productArray[i].xR) {
						xR = productArray[i].xR;
					};
					if (productArray[i].yB) {
						yB = productArray[i].yB;
					};
					if (productArray[i].canvasHeight) {
						canvasHeight = productArray[i].canvasHeight;
					};
					if (productArray[i].canvasWidth) {
						canvasWidth = productArray[i].canvasWidth;
					};
					//--------
					//OPTIONAL
					//--------
					if (productArray[i].bespokeValue) {
						bespokeValue = productArray[i].bespokeValue;
					};
					if (productArray[i].bespokePrefix) {
						bespokePrefix = productArray[i].bespokePrefix;
					};
					if (productArray[i].bespokePrefix2) {
						bespokePrefix2 = productArray[i].bespokePrefix2;
					};
					if (productArray[i].bespokeSuffix) {
						bespokeSuffix = productArray[i].bespokeSuffix;
					};
					if (productArray[i].bespokeSuffix2) {
						bespokeSuffix2 = productArray[i].bespokeSuffix2;
					};
					if (productArray[i].primaryFontColor) {
						primaryFontColor = productArray[i].primaryFontColor;
					};
					if (productArray[i].verticalAlignment) {
						verticalAlignment = productArray[i].verticalAlignment;
					};
					if (productArray[i].fontSizeRatio) {
						fontSizeRatio = productArray[i].fontSizeRatio;
					};
					if (productArray[i].caseRule) {
						caseRule = productArray[i].caseRule;
					};
					if (productArray[i].horizontalAlignment) {
						horizontalAlignment = productArray[i].horizontalAlignment;
					};
					if (productArray[i].fontFamilyBase) {
						fontFamilyBase = productArray[i].fontFamilyBase;
					};
					if (productArray[i].primaryFontColor2) {
						primaryFontColor2 = productArray[i].primaryFontColor2;
					};
					if (productArray[i].strokeScale) {
						strokeScale = productArray[i].strokeScale;
					};
					if (productArray[i].dropshadowScale) {
						dropshadowScale = productArray[i].dropshadowScale;
					};
					if (productArray[i].stroke) {
						stroke = productArray[i].stroke;
					};
					if (productArray[i].strokeColor) {
						strokeColor = productArray[i].strokeColor;
					};
					if (productArray[i].strokeWidth) {
						strokeWidth = productArray[i].strokeWidth;
					};
					if (productArray[i].shadowFontColor) {
						shadowFontColor = productArray[i].shadowFontColor;
					};
					if (productArray[i].shadowBlur) {
						shadowBlur = productArray[i].shadowBlur;
					};
					if (productArray[i].shadowOffsetX) {
						shadowOffsetX = productArray[i].shadowOffsetX;
					};
					if (productArray[i].shadowOffsetY) {
						shadowOffsetY = productArray[i].shadowOffsetY;
					};
					if (productArray[i].dropshadow) {
						dropshadow = productArray[i].dropshadow;
					};
					if (productArray[i].dropshadowScale) {
						dropshadowScale = productArray[i].dropshadowScale;
					};
					if (productArray[i].centerRotationDeg) {
						centerRotationDeg = productArray[i].centerRotationDeg;
					};
					if (productArray[i].centerRotationX) {
						centerRotationX = productArray[i].centerRotationX;
					};
					if (productArray[i].centerRotationY) {
						centerRotationY = productArray[i].centerRotationY;
					};
					if (productArray[i].zoom) {
						zoom = productArray[i].zoom;
					};
					if (productArray[i].duplicateText) {
						duplicateText = productArray[i].duplicateText;
					};
					if (productArray[i].duplicateTextSpacer) {
						duplicateTextSpacer = productArray[i].duplicateTextSpacer;
					};
					// if (productArray[i].textLength) {
					// 	textLength = productArray[i].textLength;
					// };
					if (productArray[i].debug) {
						debug = productArray[i].debug;
					};

                    if (productArray[i].cloudFolder) {
						cloudFolder = productArray[i].cloudFolder;
					};
                  
                  
                  	if (productArray[i].productImageBlank) {
						productImageBlank = productArray[i].productImageBlank;
					};

					// Old method end --- deprecated
					//--------
					if (debug == 1) {
						console.log(i + " MATCH! " + sku);
					}
				}
			}
			
			$("#canvas").attr({
				width: canvasWidth,
				height: canvasHeight
			}).css({
				maxWidth: canvasWidth
			});
			if (debug == 1) {
				var imageType = "TEXT";
			} else {
				var imageType = "BLANK";
			}

			function checkIfImageExists(url, callback) {
				const img = new Image();

				img.src = url;

				if (img.complete) {
				  callback(true);
				} else {
				  img.onload = () => {
					callback(true);
				  };
				  img.onerror = () => {
					callback(false);
				  };
				}
			  }

              function loadBackground(){
              
                var productSKU = "";

				if(useCloud == 0){
					$("#canvas").css('background-image', "url('" + _image + "')");
					$("#canvas-icon").css('background-image', "url('" + _image + "')");
                }else if (useCloud == 2){
                	$("#canvas").css('background-image', "url('" + productImageBlank + "')");
					$("#canvas-icon").css('background-image', "url('" + productImageBlank + "')");
                }
              
              	else{
					// if(debug == 1){
					//  	var imageType = "TEXT";
					// }else{
						var imageType = "BLANK";
					// }
					if(getVariant(fullSKU) !== null){
						productSKU = pcode+"_"+getVariant(fullSKU);
					}else{
						productSKU = pcode;
					}
					  checkIfImageExists(cloudURL+"/"+cloudFolder+"/"+productSKU+"_"+imageType+".jpg", (exists) => {
						if (exists) {
						  // Success code
							$("#canvas").css('background-image', "url('"+cloudURL+"/"+cloudFolder+"/"+productSKU+"_"+imageType+".jpg')");
							$("#canvas-icon").css('background-image', "url('"+cloudURL+"/"+cloudFolder+"/"+productSKU+"_"+imageType+".jpg')");
							if(debug == 1) {
								console.log("url1('" + cloudURL + "/" + cloudFolder + "/" + productSKU + "_" + imageType + ".jpg')");
							}
						}else{
						  // Failure code
							$("#canvas").css('background-image', "url('"+cloudURL+"/"+cloudFolder+"/"+pcode+"_"+imageType+".jpg')");
							$("#canvas-icon").css('background-image', "url('"+cloudURL+"/"+cloudFolder+"/"+pcode+"_"+imageType+".jpg')");
							if(debug == 1) {
								console.log("url1('" + cloudURL + "/" + cloudFolder + "/" + pcode + "_" + imageType + ".jpg')");
							}
						}
					  });
				}
			}
			loadBackground();


			$("#title").css({
				textTransform: caseRule
			});
			String.prototype.capitalize = function() {
				return this.replace(/(?:^|\s)\S/g, function(a) {
					return a.toUpperCase();
				});
			};

			function writeStuff() {

				var gradTop;
				var gradBottom;

				let text_array = textArray;

				ctx.fillStyle = "rgba(255, 255, 255, 0)";
				ctx.clearRect(0, 0, canvas.width, canvas.height);
				ctx.fillRect(0, 0, canvas.width, canvas.height);
				ctx.fillStyle = '#6F9E94';

				if(text_array.length !== 0){

					for (t = 0; t < text_array.length; t++) {
						bespokeSuffix = "";
						bespokeSuffix2 = "";
						bespokePrefix = "";
						bespokePrefix2 = "";

						if(text_array[t].customTextInput){customTextInput = text_array[t].customTextInput;};
						if(text_array[t].customTextOutput){customTextOutput = text_array[t].customTextOutput;};

						if(text_array[t].originalFontSize){originalFontSize = text_array[t].originalFontSize;};

						if(text_array[t].bespokeValue){bespokeValue = text_array[t].bespokeValue;};
						if(text_array[t].primaryFontColor){primaryFontColor = text_array[t].primaryFontColor;};
						if(text_array[t].verticalAlignment){verticalAlignment = text_array[t].verticalAlignment;};
						if(text_array[t].fontSizeRatio){fontSizeRatio = text_array[t].fontSizeRatio;};
						if(text_array[t].caseRule){caseRule = text_array[t].caseRule;};
						if(text_array[t].horizontalAlignment){horizontalAlignment = text_array[t].horizontalAlignment;};
						if(text_array[t].fontFamilyBase){fontFamilyBase = text_array[t].fontFamilyBase;};
						if(text_array[t].primaryFontColor2){primaryFontColor2 = text_array[t].primaryFontColor2;};
						if(text_array[t].strokeScale){strokeScale = text_array[t].strokeScale;};
						if(text_array[t].dropshadowScale){dropshadowScale = text_array[t].dropshadowScale;};
						if(text_array[t].stroke){stroke = text_array[t].stroke;};
						if(text_array[t].strokeColor){strokeColor = text_array[t].strokeColor;};
						if(text_array[t].strokeWidth){strokeWidth = text_array[t].strokeWidth;};
						if(text_array[t].shadowFontColor){shadowFontColor = text_array[t].shadowFontColor;};
						if(text_array[t].shadowBlur){shadowBlur = text_array[t].shadowBlur;};
						if(text_array[t].shadowOffsetX){shadowOffsetX = text_array[t].shadowOffsetX;};
						if(text_array[t].shadowOffsetY){shadowOffsetY = text_array[t].shadowOffsetY;};
						if(text_array[t].dropshadow){dropshadow = text_array[t].dropshadow;};
						if(text_array[t].dropshadowScale){dropshadowScale = text_array[t].dropshadowScale;};
						if(text_array[t].centerRotationDeg){centerRotationDeg = text_array[t].centerRotationDeg;};
						if(text_array[t].centerRotationX){centerRotationX = text_array[t].centerRotationX;};
						if(text_array[t].centerRotationY){centerRotationY = text_array[t].centerRotationY;};
						if(text_array[t].zoom){zoom = text_array[t].zoom;};
						if(text_array[t].caseRule){caseRule = text_array[t].caseRule;};
						if(text_array[t].bespokeSuffix){bespokeSuffix = text_array[t].bespokeSuffix;};
						if(text_array[t].bespokeSuffix2){bespokeSuffix2 = text_array[t].bespokeSuffix2;};
						if(text_array[t].bespokePrefix){bespokePrefix = text_array[t].bespokePrefix;};
						if(text_array[t].bespokePrefix2){bespokePrefix2 = text_array[t].bespokePrefix2;};

						let xL = text_array[t].xL;
						let yT = text_array[t].yT;
						let xR = text_array[t].xR;
						let yB = text_array[t].yB;

						var fontFamily = fontFamilyBase;
						var sizeMultiplier = originalFontSize / 100;

						if(!text_array[t].customTextInput){
							var stringBox = document.getElementById('title');
						}else{
							var stringBox = document.getElementById(customTextInput);
						}

						var stringTitle = stringBox.value;
						switch (caseRule) {
							case 'capitalize':
								if(!text_array[t].customTextInput) {
									$('#title').val(stringTitle.toLowerCase().capitalize());
								}
								stringTitle = stringTitle.toLowerCase().capitalize().replace(/\s+/g, ' ').trim();
								break;
							case 'lowercase':
								if(!text_array[t].customTextInput) {
									$('#title').val(stringTitle.toLowerCase());
								}
								stringTitle = stringTitle.toLowerCase().replace(/\s+/g, ' ').trim();
								break;
							case 'uppercase':
								if(!text_array[t].customTextInput) {
									$('#title').val(stringTitle.toUpperCase());
								}
								stringTitle = stringTitle.toUpperCase().replace(/\s+/g, ' ').trim();
								break;
							default:
								//do nothing
								break;
						}
						// stringBox.maxLength = textLength;

						if (stringTitle) {

							let stringInputted = stringTitle;

							if (bespokePrefix) {
								stringTitle = bespokePrefix.concat(stringTitle);
							}
							if (bespokePrefix2 != 0) {
								stringTitle = stringInputted.substring(0, bespokePrefix2).concat(stringTitle);
							}

							if (duplicateText == "before") {
								stringTitle = stringInputted.split('').join(duplicateTextSpacer).concat(stringTitle);
							}

							if (bespokeSuffix &&
								bespokeSuffix != stringTitle.substr(-bespokeSuffix.length) &&
								bespokeSuffix.substr(0, bespokeSuffix.length - 1) != stringTitle.substr(-bespokeSuffix.length + 1)) {
								if (stringTitle.substr(-1) != "S" && stringTitle.substr(-1) != "s") {
									stringTitle = stringTitle.concat(bespokeSuffix);
								} else {
									stringTitle = stringTitle.concat(bespokeSuffix2);
								}
							} else if (bespokeSuffix &&
								bespokeSuffix == stringTitle.substr(-bespokeSuffix.length)) {
								newStringTitle = stringTitle.slice(0, -bespokeSuffix.length);
								$('#title').val(newStringTitle);
							} else if (bespokeSuffix &&
								bespokeSuffix.substr(0, bespokeSuffix.length - 1) == stringTitle.substr(-bespokeSuffix.length + 1)) {
								newStringTitle = stringTitle.slice(0, -bespokeSuffix.length + 1);
								$('#title').val(newStringTitle);
							}

							if (duplicateText == "after") {
								stringTitle = stringTitle + stringInputted.split('').join(duplicateTextSpacer);
							}
						}
						if (!stringTitle || stringTitle == bespokeSuffix) {
							stringTitle = bespokeValue;
						}
						newFontSize = originalFontSize * ratio;
						ctx.font = originalFontSize + 'px ' + fontFamily;
						ctx.textAlign = horizontalAlignment;
						var text_title = stringTitle;
						var textWidth = ctx.measureText(stringTitle).width;
						if (textWidth > (xR - xL)) {
							ratio = ((xR - xL) / textWidth) * .95;
						} else {
							ratio = originalRatio;
						}
						newFontSize = originalFontSize * ratio;
						newFontPosX = canvas.width / 2 - (newFontSize * .02);
						if (horizontalAlignment == 'left') {
							newFontPosX = xL;
						}
						if (horizontalAlignment == 'center') {
							newFontPosX = xL + (xR - xL) / 2;
						}
						if (horizontalAlignment == 'right') {
							newFontPosX = xL + (xR - xL);
						}
						newFontPosY = canvas.height / 2 + 35 * sizeMultiplier;
						if (verticalAlignment == 'top') {
							newFontPosY = yT - 30 * fontSizeRatio * ratio;
							ctx.textBaseline = 'top';
							gradTop = yT;
							gradBottom = yB;
						}
						if (verticalAlignment == 'center') {
							newFontPosY = yT + (yB - yT) / 2 + (newFontSize / fontSizeRatio / 2);
							gradTop = yT + (yB - yT) / 2 - (newFontSize / 3);
							gradBottom = yT + (yB - yT) / 2 + (newFontSize / 3);
						}
						if (verticalAlignment == 'bottom') {
							newFontPosY = yB;
							gradTop = yB - (newFontSize * .5) * sizeMultiplier;
							gradBottom = yB;
						}
						ctx.font = newFontSize + 'px ' + fontFamily;
						if (debug == 1 || showBounds) {
							ctx.beginPath();
							ctx.rect(xL, yT, xR - xL, yB - yT);
							ctx.strokeStyle = 'rgba(255,0,0,0.5)';
							ctx.stroke();
						}
						if (dropshadow) {
							ctx.shadowColor = shadowFontColor;
							ctx.shadowBlur = shadowBlur;
							if (dropshadowScale) {
								ctx.shadowOffsetX = (shadowOffsetX / originalFontSize) * newFontSize;
								ctx.shadowOffsetY = (shadowOffsetY / originalFontSize) * newFontSize;
							} else {
								ctx.shadowOffsetX = (shadowOffsetX / originalFontSize) * newFontSize / ratio;
								ctx.shadowOffsetY = (shadowOffsetY / originalFontSize) * newFontSize / ratio;
							}
							if (centerRotationDeg) {
								degree_amt = 180 / centerRotationDeg;
								ctx.save();
								ctx.translate(centerRotationX, centerRotationY);
								ctx.rotate(-Math.PI / degree_amt);
								ctx.textAlign = 'center';
								ctx.fillText(stringTitle, 0, newFontPosY);
								ctx.restore();
							} else {
								ctx.fillText(stringTitle, newFontPosX, newFontPosY);
							}
						}
						ctx.shadowBlur = 0;
						ctx.shadowOffsetX = 0;
						ctx.shadowOffsetY = 0;
						if (stroke2) {
							ctx.miterLimit = 2.5;
							ctx.strokeStyle = strokeColor2;
							ctx.lineWidth = Math.floor(newFontSize * strokeWidth2);
							console.log("lineWidth: " + Math.floor(newFontSize * strokeWidth2));
							ctx.shadowColor = strokeColor2;
							ctx.shadowBlur = strokeBlur2;
							if (centerRotationDeg) {
								degree_amt = 180 / centerRotationDeg;
								ctx.save();
								ctx.translate(centerRotationX, centerRotationY);
								ctx.rotate(-Math.PI / degree_amt);
								ctx.textAlign = 'center';
								ctx.strokeText(stringTitle, 0, newFontPosY);
								ctx.restore();
							} else {
								ctx.strokeText(stringTitle, newFontPosX, newFontPosY);
							}
						}
						ctx.shadowBlur = 0;
						if (stroke) {
							ctx.miterLimit = 2.5;
							ctx.strokeStyle = strokeColor;
							if (strokeScale) {
								_strokeWidth = strokeWidth;
							} else {
								_strokeWidth = strokeWidth / ratio;
							}
							ctx.lineWidth = Math.floor(newFontSize * strokeWidth);
							if (centerRotationDeg) {
								degree_amt = 180 / centerRotationDeg;
								ctx.save();
								ctx.translate(centerRotationX, centerRotationY);
								ctx.rotate(-Math.PI / degree_amt);

								ctx.textAlign = 'center';
								ctx.strokeText(stringTitle, 0, newFontPosY);
								ctx.restore();
							} else {
								ctx.strokeText(stringTitle, newFontPosX, newFontPosY);
							}
							if (strokeWidth > .09) {
								ctx.lineWidth = Math.floor(newFontSize * .09);
								ctx.strokeText(stringTitle, newFontPosX, newFontPosY);
							}
						}
						ctx.lineWidth = 1;
						ctx.miterLimit = 0;
						if (primaryFontColor2) {
							var grdOffset = (gradBottom - gradTop) * gradOffset;
							if (gradientDirection == "horizontal") {
								var grd = ctx.createLinearGradient(textWidth / 2 * gradOffset, 25, -textWidth / 2 * gradOffset, 0);
							} else {
								var grd = ctx.createLinearGradient(0, gradTop + grdOffset, 0, gradBottom - grdOffset);
							}
							grd.addColorStop(0, primaryFontColor);
							grd.addColorStop(1, primaryFontColor2);
							ctx.fillStyle = grd;
						} else {
							ctx.fillStyle = primaryFontColor;
						}
						if (centerRotationDeg) {
							degree_amt = 180 / centerRotationDeg;
							ctx.save();
							ctx.translate(centerRotationX, centerRotationY);
							ctx.rotate(-Math.PI / degree_amt);

							ctx.textAlign = 'center';
							ctx.fillText(stringTitle, 0, newFontPosY);

							ctx.restore();
							if (debug == 1) {
								ctx.fillStyle = 'red';
								ctx.fillRect(centerRotationX, centerRotationY, 3, 3);
							}
						} else {
							ctx.fillText(stringTitle, newFontPosX, newFontPosY);
						}
						textWidth = ctx.measureText(stringTitle).width;


						if(!text_array[t].customTextInput) {
							if(text_array[t].customTextOutput) {
								document.getElementById(customTextOutput).value = stringTitle;
							}else{
								customTextValue = stringTitle;
							}
						}else{
							if(text_array[t].customTextOutput) {
								document.getElementById(customTextOutput).value = stringTitle;
							}
						}

						if (debug == 1) {
							console.log("Canvas Width: " + canvas.width);
							console.log("textWidth: " + textWidth);
							console.log("Ratio: " + ratio);
							console.log("Size Multiplier: " + sizeMultiplier);
							console.log("Text Y Pos: " + newFontPosY);
							console.log("gradTop: " + gradTop);
							console.log("gradBottom: " + gradBottom);
							console.log("stringTitle: " + stringTitle);
						}
					}

				}else{

					// Old method start --- deprecated

					var sizeMultiplier = originalFontSize / 100;
					var gradTop;
					var gradBottom;
					var fontFamily = fontFamilyBase;
					var stringBox = document.getElementById('title');
					var stringTitle = stringBox.value;
					switch (caseRule) {
						case 'capitalize':
							$('#title').val(stringTitle.toLowerCase().capitalize());
							stringTitle = stringTitle.toLowerCase().capitalize().replace(/\s+/g, ' ').trim();
							break;
						case 'lowercase':
							$('#title').val(stringTitle.toLowerCase());
							stringTitle = stringTitle.toLowerCase().replace(/\s+/g, ' ').trim();
							break;
						case 'uppercase':
							$('#title').val(stringTitle.toUpperCase());
							stringTitle = stringTitle.toUpperCase().replace(/\s+/g, ' ').trim();
							break;
						default:
							//do nothing
							break;
					}
					// stringBox.maxLength = textLength;

					if (stringTitle) {

						let stringInputted = stringTitle;

						if (bespokePrefix) {
							stringTitle = bespokePrefix.concat(stringTitle);
						}
						if (bespokePrefix2 != 0) {
							stringTitle = stringInputted.substring(0, bespokePrefix2).concat(stringTitle);
						}

						if (duplicateText == "before") {
							stringTitle = stringInputted.split('').join(duplicateTextSpacer).concat(stringTitle);
						}

						if (bespokeSuffix &&
							bespokeSuffix != stringTitle.substr(-bespokeSuffix.length) &&
							bespokeSuffix.substr(0, bespokeSuffix.length - 1) != stringTitle.substr(-bespokeSuffix.length + 1)) {
							if (stringTitle.substr(-1) != "S" && stringTitle.substr(-1) != "s") {
								stringTitle = stringTitle.concat(bespokeSuffix);
							} else {
								stringTitle = stringTitle.concat(bespokeSuffix2);
							}
						} else if (bespokeSuffix &&
							bespokeSuffix == stringTitle.substr(-bespokeSuffix.length)) {
							newStringTitle = stringTitle.slice(0, -bespokeSuffix.length);
							$('#title').val(newStringTitle);
						} else if (bespokeSuffix &&
							bespokeSuffix.substr(0, bespokeSuffix.length - 1) == stringTitle.substr(-bespokeSuffix.length + 1)) {
							newStringTitle = stringTitle.slice(0, -bespokeSuffix.length + 1);
							$('#title').val(newStringTitle);
						}

						if (duplicateText == "after") {
							stringTitle = stringTitle + stringInputted.split('').join(duplicateTextSpacer);
						}
					}
					if (!stringTitle || stringTitle == bespokeSuffix) {
						stringTitle = bespokeValue;
					}
					ctx.fillStyle = "rgba(255, 255, 255, 0)";
					ctx.clearRect(0, 0, canvas.width, canvas.height);
					ctx.fillRect(0, 0, canvas.width, canvas.height);
					ctx.fillStyle = '#6F9E94';
					newFontSize = originalFontSize * ratio;
					ctx.font = originalFontSize + 'px ' + fontFamily;
					ctx.textAlign = horizontalAlignment;
					var text_title = stringTitle;
					var textWidth = ctx.measureText(stringTitle).width;
					if (textWidth > (xR - xL)) {
						ratio = ((xR - xL) / textWidth) * .95;
					} else {
						ratio = originalRatio;
					}
					newFontSize = originalFontSize * ratio;
					newFontPosX = canvas.width / 2 - (newFontSize * .02);
					if (horizontalAlignment == 'left') {
						newFontPosX = xL;
					}
					if (horizontalAlignment == 'center') {
						newFontPosX = xL + (xR - xL) / 2;
					}
					if (horizontalAlignment == 'right') {
						newFontPosX = xL + (xR - xL);
					}
					newFontPosY = canvas.height / 2 + 35 * sizeMultiplier;
					if (verticalAlignment == 'top') {
						newFontPosY = yT - 30 * fontSizeRatio * ratio;
						ctx.textBaseline = 'top';
						gradTop = yT;
						gradBottom = yB;
					}
					if (verticalAlignment == 'center') {
						newFontPosY = yT + (yB - yT) / 2 + (newFontSize / fontSizeRatio / 2);
						gradTop = yT + (yB - yT) / 2 - (newFontSize / 3);
						gradBottom = yT + (yB - yT) / 2 + (newFontSize / 3);
					}
					if (verticalAlignment == 'bottom') {
						newFontPosY = yB;
						gradTop = yB - (newFontSize * .5) * sizeMultiplier;
						gradBottom = yB;
					}
					ctx.font = newFontSize + 'px ' + fontFamily;
					if (debug == 1 || showBounds) {
						ctx.beginPath();
						ctx.rect(xL, yT, xR - xL, yB - yT);
						ctx.strokeStyle = 'rgba(255,0,0,0.5)';
						ctx.stroke();
					}
					if (dropshadow) {
						ctx.shadowColor = shadowFontColor;
						ctx.shadowBlur = shadowBlur;
						if (dropshadowScale) {
							ctx.shadowOffsetX = (shadowOffsetX / originalFontSize) * newFontSize;
							ctx.shadowOffsetY = (shadowOffsetY / originalFontSize) * newFontSize;
						} else {
							ctx.shadowOffsetX = (shadowOffsetX / originalFontSize) * newFontSize / ratio;
							ctx.shadowOffsetY = (shadowOffsetY / originalFontSize) * newFontSize / ratio;
						}
						if (centerRotationDeg) {
							degree_amt = 180 / centerRotationDeg;
							ctx.save();
							ctx.translate(centerRotationX, centerRotationY);
							ctx.rotate(-Math.PI / degree_amt);
							ctx.textAlign = 'center';
							ctx.fillText(stringTitle, 0, newFontPosY);
							ctx.restore();
						} else {
							ctx.fillText(stringTitle, newFontPosX, newFontPosY);
						}
					}
					ctx.shadowBlur = 0;
					ctx.shadowOffsetX = 0;
					ctx.shadowOffsetY = 0;
					if (stroke2) {
						ctx.miterLimit = 2.5;
						ctx.strokeStyle = strokeColor2;
						ctx.lineWidth = Math.floor(newFontSize * strokeWidth2);
						console.log("lineWidth: " + Math.floor(newFontSize * strokeWidth2));
						ctx.shadowColor = strokeColor2;
						ctx.shadowBlur = strokeBlur2;
						if (centerRotationDeg) {
							degree_amt = 180 / centerRotationDeg;
							ctx.save();
							ctx.translate(centerRotationX, centerRotationY);
							ctx.rotate(-Math.PI / degree_amt);
							ctx.textAlign = 'center';
							ctx.strokeText(stringTitle, 0, newFontPosY);
							ctx.restore();
						} else {
							ctx.strokeText(stringTitle, newFontPosX, newFontPosY);
						}
					}
					ctx.shadowBlur = 0;
					if (stroke) {
						ctx.miterLimit = 2.5;
						ctx.strokeStyle = strokeColor;
						if (strokeScale) {
							_strokeWidth = strokeWidth;
						} else {
							_strokeWidth = strokeWidth / ratio;
						}
						ctx.lineWidth = Math.floor(newFontSize * strokeWidth);
						if (centerRotationDeg) {
							degree_amt = 180 / centerRotationDeg;
							ctx.save();
							ctx.translate(centerRotationX, centerRotationY);
							ctx.rotate(-Math.PI / degree_amt);

							ctx.textAlign = 'center';
							ctx.strokeText(stringTitle, 0, newFontPosY);
							ctx.restore();
						} else {
							ctx.strokeText(stringTitle, newFontPosX, newFontPosY);
						}
						if (strokeWidth > .09) {
							ctx.lineWidth = Math.floor(newFontSize * .09);
							ctx.strokeText(stringTitle, newFontPosX, newFontPosY);
						}
					}
					ctx.lineWidth = 1;
					ctx.miterLimit = 0;
					if (primaryFontColor2) {
						var grdOffset = (gradBottom - gradTop) * gradOffset;
						if (gradientDirection == "horizontal") {
							var grd = ctx.createLinearGradient(textWidth / 2 * gradOffset, 25, -textWidth / 2 * gradOffset, 0);
						} else {
							var grd = ctx.createLinearGradient(0, gradTop + grdOffset, 0, gradBottom - grdOffset);
						}
						grd.addColorStop(0, primaryFontColor);
						grd.addColorStop(1, primaryFontColor2);
						ctx.fillStyle = grd;
					} else {
						ctx.fillStyle = primaryFontColor;
					}
					if (centerRotationDeg) {
						degree_amt = 180 / centerRotationDeg;
						ctx.save();
						ctx.translate(centerRotationX, centerRotationY);
						ctx.rotate(-Math.PI / degree_amt);

						ctx.textAlign = 'center';
						ctx.fillText(stringTitle, 0, newFontPosY);

						ctx.restore();
						if (debug == 1) {
							ctx.fillStyle = 'red';
							ctx.fillRect(centerRotationX, centerRotationY, 3, 3);
						}
					} else {
						ctx.fillText(stringTitle, newFontPosX, newFontPosY);
					}
					textWidth = ctx.measureText(stringTitle).width;
					customTextValue = stringTitle;
					if (debug == 1) {
						console.log("Canvas Width: " + canvas.width);
						console.log("textWidth: " + textWidth);
						console.log("Ratio: " + ratio);
						console.log("Size Multiplier: " + sizeMultiplier);
						console.log("Text Y Pos: " + newFontPosY);
						console.log("gradTop: " + gradTop);
						console.log("gradBottom: " + gradBottom);
						console.log("stringTitle: " + stringTitle);
					}

					return stringTitle;
				}
				// Old method end --- deprecated

				return customTextValue;
			}
			document.getElementById('title').addEventListener('keyup', function() {
				// writeStuff();
				document.getElementById('personalisation-final').value = writeStuff();

			});
			for (let i = 0; i < fontFamilyArray.length; i++) {
				fontSpy(fontFamilyArray[i], {
					success: function () {
						if (debug == 1) {
							console.log("font '" + fontFamilyArray[i] + "' loaded successfully");
						}
						writeStuff();
					},
					failure: function () {
						if (debug == 1) {
							console.log("font '" + fontFamilyArray[i] + "' failed to load");
						}
						writeStuff();
					}
				});
			}
			$("input").alphanum({
				allow: '\'&+!=/,.!@£$%^&*()_+}{|":?><~/.,\';][-`',
				disallow: '',
				allowSpace: true,
				allowNumeric: true,
				allowUpper: true,
				allowLower: true,
				allowCaseless: true,
				allowLatin: true,
				allowOtherCharSets: true,
				forceUpper: false,
				forceLower: false,
				maxLength: NaN
			});
		}
	}
})(this, jQuery);